import eduIcon1 from '@/assets/images/home/edu-icon1.webp';
import eduIcon2 from '@/assets/images/home/edu-icon2.webp';
import eduIcon3 from '@/assets/images/home/edu-icon3.webp';

import eduIcon1png from '@/assets/images/home/edu-icon1.png';
import eduIcon2png from '@/assets/images/home/edu-icon2.png';
import eduIcon3png from '@/assets/images/home/edu-icon3.png';

export const customData = {
  title: 'WPS 365教育版助力更多院校实现数智化转型',
};
export const eduData = {
  title: '数字化教育平台',
  subtitle:
    '专为国内教育场景打造的数字化解决方案，帮助您的机构简化工作、提升效率',
  introduceList: [
    {
      title: '教学教研',
      desc: '「WPS 365 教育版」为教师提供了丰富的教学工具和教学素材，帮助教师更高效地备课、教学、评估、追踪和分析，省下时间专注于培养学生。',
      icon: eduIcon1,
      pngIcon: eduIcon1png,
    },
    {
      title: '教务管理',
      desc: '协作收集的数据自动汇总、存储、便于高效筛选、复用和导出，通过可视化视图直观呈现，提升数据价值。高效解决校内复杂事务，助力校园管理。',
      icon: eduIcon2,
      pngIcon: eduIcon2png,
    },
    {
      title: '辅助学习',
      desc: '借助知识全生命周期管理方案，帮助学生高效收集、沉淀、管理、使用知识。还有多种易用的学习工具，持续提升学生学习效率。',
      icon: eduIcon3,
      pngIcon: eduIcon3png,
    },
  ],
};